import { component } from "tsdi";

@component
export class AudioInput {}
